// Map the icon strings stored in the DB modules table to real icon components.
import {
  FiDatabase, FiSettings, FiUsers, FiShield, FiHome,
  FiLock, FiBriefcase, FiSliders, FiGrid, FiPackage, FiShoppingCart, FiTool,
} from 'react-icons/fi';

const MAP = {
  package: FiPackage, 'shopping-cart': FiShoppingCart, tool: FiTool,
  database: FiDatabase,
  settings: FiSettings,
  users: FiUsers,
  shield: FiShield,
  building: FiHome,
  lock: FiLock,
  briefcase: FiBriefcase,
  sliders: FiSliders,
};

export function Icon({ name, ...props }) {
  const Cmp = MAP[name] || FiGrid;
  return <Cmp {...props} />;
}
